import { CommonModule } from '@angular/common';
import { Component, TemplateRef, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class PromptComponent {
  dialogRef = inject<MatDialogRef<PromptComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    content: string;
    template: TemplateRef<unknown>;
  }>(MAT_DIALOG_DATA);
}
